import * as Reflux from "reflux";
export const EmployeeOrderHeaderActions = {
	setPayment: Reflux.createAction(["setPayment"]),
	setDefaultPayment: Reflux.createAction(["setDefaultPayment"]),
	setOrderSource: Reflux.createAction(["setOrderSource"]),
	setDeliveryAddress: Reflux.createAction(["setDeliveryAddress"]),
	// Checkboxes...
	setSingleOrder: Reflux.createAction(["setSingleOrder"]),
	setSendOrderConfirmationToCardholder: Reflux.createAction(["setSendOrderConfirmationToCardholder"]),
	setSendOrderConfirmationToCustomer: Reflux.createAction(["setSendOrderConfirmationToCustomer"]),
	setIgnoreFees: Reflux.createAction(["setIgnoreFees"]),
	setSendPickingListToCentralWarehouse: Reflux.createAction(["setSendPickingListToCentralWarehouse"]),
	// Comments...
	setCustomerDataAdditions: Reflux.createAction(["setCustomerDataAdditions"]),
	setShoppingCartComment: Reflux.createAction(["setShoppingCartComment"]),
	setEgalisationTaxFlag: Reflux.createAction(["setEgalisationTaxFlag"]),
	setOwnOrderNumber: Reflux.createAction(["setOwnOrderNumber"]),
	setOwnStoreNumber: Reflux.createAction(["setOwnStoreNumber"]),
};
